import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; 
import '../css/AssessmentForm.css';
import Submitting from './Submitting';
import { Button } from "flowbite-react";

function AssessmentForm() {
    const location = useLocation();
    const navigate = useNavigate(); 
    const interviewQuestions = location.state?.interviewQuestions || [];
    const jobRole = location.state?.jobRole || ''; 
    const Uid = location.state?.Uid || '';
    const briefDescription = location.state?.briefDescription || ''; 
    const [responses, setResponses] = useState(Array(interviewQuestions.length).fill(''));
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [isReviewMode, setIsReviewMode] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (index, value) => {
        const newResponses = [...responses];
        newResponses[index] = value;
        setResponses(newResponses);
    };

    const handleNext = () => {
        if (currentQuestionIndex < interviewQuestions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            setIsReviewMode(true);
        }
    };

    const handleBack = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const handleReviewBack = () => {
        setIsReviewMode(false);
    };

    const handleSubmit = () => {
        setIsSubmitting(true);
        fetch(
            `${process.env.REACT_APP_API_URL}/submit-assessment` +
              "?key=" +
              process.env.REACT_APP_API_KEY,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                responses: responses,
                job_role: jobRole,
                Uid:Uid
              }),
            }
          )
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            console.log("Assessment submitted:", data);
            //navigate("/assessment-results", { state: { analysis: data.analysis } });
          })
          .catch((error) => {
            console.error("Error submitting assessment:", error);
            // You might want to show an error message to the user here
          })
          .finally(() => {
            setIsSubmitted(true);
        });
    };

    return (
        <div className='assessment-page'>
            <div className='questions-section'>
            {interviewQuestions.length > 0 ? (
                <>
                    {!isReviewMode ? (
                        <>
                            <div className='interview-question-header'>
                                <p>{interviewQuestions[currentQuestionIndex]}</p>
                                <div className='button-section'>
                                    <p>{`Question ${currentQuestionIndex + 1} of ${interviewQuestions.length}`}</p>
                                    {currentQuestionIndex > 0 && (
                                        <Button className="previous-question" onClick={handleBack}>Previous Question</Button>
                                    )}
                                    <Button className="next-question" onClick={handleNext} disabled={!responses[currentQuestionIndex].trim()}>
                                        {currentQuestionIndex < interviewQuestions.length - 1 ? 'Next' : 'Review Answers'}
                                    </Button>
                                </div>
                            </div>
                            <div className='interview-question-body'>
                                <textarea
                                    className='answer-box'
                                    value={responses[currentQuestionIndex]}
                                    onChange={(e) => handleChange(currentQuestionIndex, e.target.value)}
                                    rows="4"
                                    cols="50"
                                />
                            </div>
                        </>
                    ) : (
                        <div className='review-section'>
                            <h2>Review Your Answers</h2>
                            {interviewQuestions.map((question, index) => (
                                <div key={index} className='review-item'>
                                    <p><strong>Question {index + 1}:</strong> {question}</p>
                                    <p><strong>Your Answer:</strong> {responses[index]}</p>
                                </div>
                            ))}
                            <div className='button-section'>
                                <Button className="review-back" onClick={handleReviewBack}>Go Back</Button>
                                <Button className="submit-assessment" onClick={handleSubmit}>Submit Evaluation</Button>
                            </div>
                            {isSubmitting && 
                                <Submitting isSubmitted={isSubmitted} />
                            }
                        </div>
                    )}
                </>
            ) : (
                <p>No interview questions available.</p>
            )}
            </div>
        </div>
    );
}

export default AssessmentForm;